export const videoProviderSchedulerAliases = {
    'zoom.us.org': 'zoom',
    'zoom.us': 'zoom'
};

export const videoProviderMeetingTypeAliases = {
    'zoom.us.org': 'zoom - account Level',
    'zoom.us': 'zoom'
};
